module.exports = __webpack_public_path__ + "img/exit.b005f114.png";